<template>
    <section class="m-opinion-part">
        <Title :titleArr="titleArr"></Title>
        <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 4}"
            placeholder="请输入内容"
            v-model="textarea2"
        ></el-input>
        <p class="u-opinion-des1">说明：针对本次评选活动及相关参选疑问，欢迎您提出宝贵意见与要求！</p>
        <a class="u-opinion-btn1" href="javascript:;" @click="postOpinion">提交</a>
    </section>
</template>

<script>
import Title from "@/components/Title";
export default {
    name: "opinion",
    components: {
        Title
    },
    data() {
        return {
            titleArr: pageDatas.opinionDatas.titleArr,
            textarea2: ""
        };
    },
    methods: {
        postOpinion() {
            var _this = this;
            let con = this.textarea2;
            if (!con) {
                _this.$message({
                    message: "请填写参选意见，我们将第一时间给你反馈！",
                    type: "warning"
                });
                return;
            }
            // 发送 POST 请求
            let url =
                "//support.finance.sina.com.cn/service/api/openapi.php/JinQiService.saveYjInfo";
            let param = new URLSearchParams();
            param.append("acode", sessionStorage.getItem("acode"));
            param.append("atype", "qs");
            param.append("brief", con);
            this.axios({
                method: "POST",
                url: url,
                data: param
            })
                .then(function(response) {
                    let data = response.data.result;
                    // console.log(data.data.status);
                    if (data.status.code == 0) {
                        // let msg = data.status.msg;
                        //  console.log(msg);
                        _this.$message({
                            message:
                                "非常感谢！参选意见提交成功，我们会及时与您取得联系！",
                            type: "success"
                        });
                    } else {
                        _this.$message({
                            message: "请稍后再试！",
                            type: "warning"
                        });
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>

<style >
</style>
